<template>
  <b-modal ref="choicesModal" title="Edit field choices" @ok="confirmChoices">
    <b-list-group class="choice-list">
      <div class="d-flex my-1 align-items-center" v-for="(choice, index) in choices" :key="index">
        <b-form-input v-model="choice.key" placeholder="value" @change="onKeyChanged(choice)" class="mx-1"></b-form-input>
        <b-form-input v-model="choice.value" placeholder="display label" class="mx-1"></b-form-input>
        <div class="text-danger" @click.prevent="removeChoice(index)">
          <font-awesome-icon icon="times" />
        </div>
      </div>
    </b-list-group>
    <b-button @click="addChoice" variant="primary" size="sm" class="mt-1"><font-awesome-icon icon="plus" /> Add</b-button>
  </b-modal>

</template>

<script>
export default {
  name: 'FieldChoices',

  props: {
    field: {type: Object, required: true}
  },

  data () {
    return {
      choices: []
    }
  },

  methods: {
    show () {
      this.choices = []
      for (let key in this.field.choices) {
        const value = this.field.choices[key]
        this.choices.push({key, value})
      }
      this.$refs.choicesModal.show()
    },

    addChoice () {
      this.choices.push({key: '', value: ''})
    },

    removeChoice (index) {
      this.choices.splice(index, 1)
    },

    confirmChoices () {
      const choices = {}
      for (let {key, value} of this.choices) {
        choices[key] = value.trim()
      }
      this.$emit('choices', choices)
    },

    onKeyChanged (c) {
      if (c.key && !c.value) {
        c.value = c.key
          .split(/[_+: /-]/)
          .filter(word => !!word)
          .map(word => word[0].toUpperCase() + word.substring(1).toLowerCase())
          .join(' ')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wizard/FieldChoices.vue